<template>
    <v-badge
        v-if="record.output"
        color="black"
        class="ml-2"
        :content="content"
        inline
    >
    </v-badge>
</template>
<script>
export default {
    props: ['record', 'count'],
    computed: {
        content() {
            return this.count ? this.count : '0'
        },
    },
}
</script>
